import React, { useState } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { Link as Button } from 'react-scroll';
import { useAuth } from '../../context/AuthContext';

import { makeStyles } from '@material-ui/core/styles';
import logo from '../../resources/logo-white.ico'; // Tell webpack this JS file uses this image

const useStyles = makeStyles({
  logo: {
    width: '60px',
  },
  title: {
    verticalAlign: 'middle',
  },
});

const Header = () => {
  const classes = useStyles();
  const { push } = useHistory();
  const { activeUser, logout } = useAuth();
  const [show, setShow] = useState(false);
  const click = () => push('/');
  return (
    <nav
      style={{ top: 0 }}
      className='navbar bg-theme shadow top-0 navbar-expand-lg position-fixed w-100 navbar-dark py-lg-0 py-3'
    >
      <div className='container-fluid align-items-start'>
        <div className='navbar-brand mr-5'>
          <img className={`${classes.logo} pr-1`} src={logo} />
          <Link
            to='/'
            className={`${classes.title} text-white text-decoration-none h2 mb-0`}
          >
            OptionFalcon
          </Link>
        </div>
        <button
          onClick={() => setShow('show')}
          className='navbar-toggler border-0'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarNav'
          aria-controls='navbarNav'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon' />
        </button>
        <div
          className={
            'collapse header_outer navbar-collapse justify-content-between ' +
            show
          }
          id='navbarNav'
        >
          <div
            className='hide_on_large text-right display-3 px-3'
            onClick={() => setShow(false)}
          >
            &times;
          </div>
          <ul className='navbar-nav small'>
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='hero'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  Home
                </span>
              </Button>
            </li>
            {/* <li className='nav-item'>
              <NavLink
                onClick={() => setShow(false)}
                exact
                activeClassName='active'
                to='/realtime'
                className='nav-link px-2 py-3 mx-2'
              >
                <span className='nav-link'>Real time UOA</span>
              </NavLink>
            </li> */}
            <li className='nav-item'>
              <NavLink
                exact
                activeClassName='active'
                to='/database'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span className='nav-link'>UOA Data</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                activeClassName="active"
                to="/dptable"
                className="nav-link px-2 py-3 mx-2"
                onClick={() => setShow(false)}
              >
                <span className="nav-link">DP Table</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                activeClassName="active"
                to="/dphis"
                className="nav-link px-2 py-3 mx-2"
                onClick={() => setShow(false)}
              >
                <span className="nav-link">DP</span>
              </NavLink>
            </li>
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='about'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  About
                </span>
              </Button>
            </li>
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='features'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  Features
                </span>
              </Button>
            </li>
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='faqs'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  FAQs
                </span>
              </Button>
            </li>
            {/* TODO add pricing back */}
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='pricing'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  Pricing
                </span>
              </Button>
            </li>
            <li className='nav-item'>
              <a href='./education/' className='nav-link px-2 py-3 mx-2'>
                <span className='nav-link'>Education</span>
              </a>
              {/* <NavLink activeClassName="active" strict to="/education/" className="nav-link px-2 py-3 mx-2" onClick={()=> setShow(false)}>
                
                  <span className="nav-link">
                    Education
                  </span>
                </NavLink> */}
            </li>
            <li className='nav-item'>
              <NavLink
                onClick={() => setShow(false)}
                exact
                activeClassName='active'
                to='/report'
                className='nav-link px-2 py-3 mx-2'
              >
                <span className='nav-link'>Report</span>
              </NavLink>
            </li>
            <li className='nav-item'>
              <NavLink
                onClick={() => setShow(false)}
                exact
                activeClassName='active'
                to='/alerts'
                className='nav-link px-2 py-3 mx-2'
              >
                <span className='nav-link'>Alerts</span>
              </NavLink>
            </li>
            <li className='nav-item'>
              <Button
                spy={true}
                smooth={true}
                activeClass='active'
                to='contact'
                className='nav-link px-2 py-3 mx-2'
                onClick={() => setShow(false)}
              >
                <span onClick={click} className='nav-link'>
                  Contact Us
                </span>
              </Button>
            </li>
          </ul>
          {activeUser.firstname ? (
            <div className='text-white position-relative nav-link d-flex'>
              <span className='user d-inline-flex mr-3'>
                {activeUser.firstname[0]}{' '}
              </span>
              <span> {activeUser.firstname} </span>
              <div className='my_dropdown'>
                <ul className='list-unstyled mb-0'>
                  {activeUser.role === 'admin' ? (
                    <li>
                      <Link onClick={() => setShow(false)} to='/users'>
                        Users
                      </Link>
                    </li>
                  ) : (
                    ''
                  )}
                  <li>
                    <Link
                      onClick={() => setShow(false)}
                      to='/profile'
                      className='btn'
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <button onClick={logout} className='btn'>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <Link
              onClick={() => setShow(false)}
              className='nav-link'
              to='/login'
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
